<div class="hero development-hero" #hero>
    <h1 class="hero__title">Development</h1>
    <div class="c-tabs desktop-only">
        <div class="tab" [ngClass]="{'tab--active' : activeTab === DevelopmentTabEnum.Development}">Developing the screening tool
            <div class="tab__hotspot" (click)="changeTab(DevelopmentTabEnum.Development)"></div>
            <div class="shadow" *ngIf="activeTab !== DevelopmentTabEnum.Development"></div>
        </div>
        <div class="tab" [ngClass]="{'tab--active' : activeTab === DevelopmentTabEnum.ConsiderationsLimitations}">Considerations & limitations
            <div class="tab__hotspot" (click)="changeTab(DevelopmentTabEnum.ConsiderationsLimitations)"></div>
            <div class="shadow" *ngIf="activeTab !== DevelopmentTabEnum.ConsiderationsLimitations"></div>
        </div>
        <div class="tab" [ngClass]="{'tab--active' : activeTab === DevelopmentTabEnum.CollaboratorsPublications}">Collaborators & publications
            <div class="tab__hotspot" (click)="changeTab(DevelopmentTabEnum.CollaboratorsPublications)"></div>
            <div class="shadow" *ngIf="activeTab !== DevelopmentTabEnum.CollaboratorsPublications"></div>
        </div>
    </div>
</div>
<app-developing-the-tool *ngIf="activeTab === DevelopmentTabEnum.Development"></app-developing-the-tool>
<app-considerations-limitations *ngIf="activeTab === DevelopmentTabEnum.ConsiderationsLimitations"></app-considerations-limitations>
<app-collaborators-publications *ngIf="activeTab === DevelopmentTabEnum.CollaboratorsPublications"></app-collaborators-publications>